import React from 'react';
import { styled } from 'linaria/react';
import CategoryLink from '@jetshop/ui/CategoryLink';
import { useQuery } from 'react-apollo';
import brandQuery from './BrandQuery.gql';
import { config } from '../../../shop.config.custom';

const BrandWrapper = styled('div')``;

export const Brand = ({ subName }) => {
  const result = useQuery(brandQuery, {
    variables: { categoryId: config.routes.brand.id },
    skip: !subName
  });

  if (!subName || subName.length === 0) return null;

  const categories = result?.data?.category?.subcategories;

  const currentCategory =
    categories && categories.filter(cat => cat.name === subName)[0];

  return (
    <BrandWrapper>
      <>
        {currentCategory ? (
          <CategoryLink category={currentCategory}>
            <p>{subName}</p>
          </CategoryLink>
        ) : (
          <p>{subName}</p>
        )}
      </>
    </BrandWrapper>
  );
};
